import React from "react";
import "./Blog_inner_Banner.css";

function Blog_inner_Banner({blogid}) {



  return (
    <section className="Blog_inner_Banner">
      <div className="Blog_inner_Banner_img_holder_main">
        <div className="Blog_inner_Banner_img_holder">
          <img
            src={process.env.REACT_APP_IMG_URL + blogid?.image}
            className="Blog_inner_Banner_img"
            alt="Blog_inner_Banner_img"
          />
        </div>

        <div className="Blog_inner_Banner_inner_text_holder">
          <div className="blog_person_img_holder">
            <img
              src={process.env.PUBLIC_URL +  "/assets/Images/Blog/Blog_inner/Blog_user/user_1.png" }
              className="blog_person_img"
              alt="blog_person_img"
            />
          </div>
          <div className="blog_name_text_holder">
            <div className="name_holder">
              <p>{blogid?.customer_name}</p>
            </div>
            <div className="description_holder">
              <p>
                How to Choose the Best Standard Business Card for Your Needs
              </p>
            </div>
          </div>
        </div>

        <div className="overlay_holder"></div>
      </div>
    </section>
  );
}

export default Blog_inner_Banner;
